/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllLocationsQuery } from '../../models/get-all-locations-query';
import { GetAllLocationsQueryResult } from '../../models/get-all-locations-query-result';

export interface ApiLocationGetAllLocationsPost$Plain$Params {
      body?: GetAllLocationsQuery
}

export function apiLocationGetAllLocationsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationGetAllLocationsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllLocationsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetAllLocationsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllLocationsQueryResult>;
    })
  );
}

apiLocationGetAllLocationsPost$Plain.PATH = '/api/Location/GetAllLocations';
